/**
 * @created on 2018/7/20
 * @author zensp <.com>
 **/

// 心理日记
const xinlidaily = resolve =>
  require(['../../../views/xinlidaily/xinlidaily'], resolve)

export default [
  // 心理日记
  {
    path: '/xinlidaily',
    component: xinlidaily
  }
]



// WEBPACK FOOTER //
// ./src/router/page/xinlidaily/xinlidaily.js